module.exports = __webpack_public_path__ + "img/index_jiejue2.063ac18e.png";